const urlMaps = {
  "localhost:3000": {
    env: "local",
    server: "http://localhost:9003/api/pay",
  },
  "localhost:3001": {
    env: "local",
    server: "http://localhost:9003/api/pay",
  },
  "localhost:3002": {
    env: "local",
    server: "http://localhost:9003/api/pay",
  },
  "dev-api-dashboard.transfi.com": {
    env: "development",
    server: "https://dev-api-dashboard-server.transfi.com/api/pay",
  },
  "qa-api-dashboard.transfi.com": {
    env: "qa",
    server: "https://qa-api-dashboard-server.transfi.com/api/pay",
  },
  "sandbox-api-dashboard.transfi.com": {
    env: "sandbox",
    server: "https://sandbox-api-dashboard-server.transfi.com/api/pay",
  },
  "api-dashboard.transfi.com": {
    env: "production",
    server: "https://api-dashboard-server.transfi.com/api/pay",
  },
};

export default urlMaps;
